import React, { ReactNode } from 'react';
import { Box } from '../../../../core-components/box';
type Props = {
  active?: boolean;
  children?: ReactNode;
};
export const NestedListContainer = ({
  active = false,
  ...rest
}: Props) => <Box display={active ? 'inline-block' : 'none'} aria-live="polite" role="region" {...rest} data-sentry-element="Box" data-sentry-component="NestedListContainer" data-sentry-source-file="NestedListContainer.tsx" />;